module.exports = __webpack_public_path__ + "img/logo.3f3f84d9.png";